export const AVATAR_PALETTE = ['#37559e','#bf6f50','#15803d','#b45309','#1d4ed8','#7c3aed','#0891b2','#be123c'];

export const getInitials = (name = '') =>
  name.trim().split(/\s+/).map(n => n[0]).join('').slice(0, 2).toUpperCase() || '?';

export const getAvatarColor = (name = '') =>
  AVATAR_PALETTE[(name.charCodeAt(0) ?? 0) % AVATAR_PALETTE.length];

export const fmt = (d) =>
  d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const STATUS_CFG = {
  active:   { label: 'Active',   cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  inactive: { label: 'Inactive', cls: 'bg-gray-100 text-gray-500 border-gray-200' },
  pending:  { label: 'Pending',  cls: 'bg-amber-50 text-amber-700 border-amber-200' },
};

export const statusCls   = (s) => (STATUS_CFG[s] || STATUS_CFG.inactive).cls;
export const statusLabel = (s) => (STATUS_CFG[s] || { label: s || 'Unknown' }).label;

export const INDUSTRIES = [
  'Technology','Finance','Healthcare','Education','Manufacturing',
  'Retail','Media','Government','Non-Profit','Construction','Other',
];

export const fieldCls = [
  'w-full px-3 py-2 rounded-xl border border-gray-200 bg-white text-sm',
  'outline-none transition-all',
  'focus:ring-2 focus:ring-[#37559e]/20 focus:border-[#37559e]',
  'hover:border-gray-300 disabled:bg-gray-50 disabled:text-gray-400',
].join(' ');
